import { lazy } from 'react';
const PriceFluctuation = lazy(() => import('./PriceFluctuation'));

const PriceFluctuationRoutes = [
  {
    path: '/pricefluctuation',
    component: PriceFluctuation
  }
];
export default PriceFluctuationRoutes;
